export const config = {
  clientKey: 'oblak',
  languageKey: 'en',
}
